export const CSV = 'text/csv';
export const XLSX =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const PDF = 'application/pdf';
